import * as React from 'react';
import Panel from './Panel';
import {GameToJoin} from './GameToJoin';
import {GameLobbyState} from './AppTypes';

interface GameLobbiesProps {
    lobbies: GameLobbyState[];
    onJoinGame: (lobby: GameLobbyState) => void;
}

export function GameLobbies({lobbies, onJoinGame}: GameLobbiesProps): JSX.Element {
    return (
        <Panel id="game-lobbies-panel">
            <p>Join a game</p>
            {lobbies.map((lobby, i) => (
                <GameToJoin key={i} lobby={lobby} onJoin={onJoinGame} />
            ))}
        </Panel>
    );
}



// WEBPACK FOOTER //
// ./src/GameLobbies.tsx